import React from "react";
import js from "../img/js.png";
import reactImg from "../img/react.png";
import tailwindImg from "../img/tailwind.png";
import bootstrapImg from "../img/bootstrap.png";
import redux from "../img/redux.png";
import next from "../img/next.png";

function Skill() {
  return (
    <div className="flex flex-wrap md:justify-start items-center justify-between">
      <div className="w-10 md:w-14 opacity-60 h-auto md:mx-2 dark:opacity-100">
        <img src={js} alt="" />
      </div>
      <div className="w-10 md:w-14 opacity-60 h-auto md:mx-2 dark:opacity-100">
        <img src={reactImg} alt="" />
      </div>
      <div className="w-10 md:w-28 opacity-60 h-auto md:mx-2 dark:opacity-100">
        <img src={next} alt="" />
      </div>
      <div className="w-10 md:w-14 opacity-60 h-auto md:mx-2 dark:opacity-100">
        <img src={redux} alt="" />
      </div>
      <div className="w-10 md:w-14 opacity-60 h-auto md:mx-2 dark:opacity-100">
        <img src={tailwindImg} alt="" />
      </div>
      <div className="w-10 md:w-14 opacity-60 h-auto md:mx-2 dark:opacity-100">
        <img src={bootstrapImg} alt="" />
      </div>
    </div>
  );
}

export default Skill;
